const checkSortingIndex = (index, id, order, updateSort) =>
  id in index ? updateSort(index[id] + order) : updateSort(null);

export default checkSortingIndex;
